<button class="btn-close btn-icon" mat-dialog-close>
  <mat-icon class="material-icons">close</mat-icon>
</button>
<mat-dialog-content>
  <div class="access-emulator">
    <div class="access-emulator__top"></div>
    <div class="access-emulator__middle">
      @for (accessGroup of accessGroups; track accessGroup; let groupIndex = $index) {
        <div class="access-group-item">
          <div class="access-group-item__name">
            <img src="/assets/img/emulator-app-charger-icon.svg" alt="OK logo" class="access-group-item__logo" />
            <span>
              {{ accessGroup.organizationName }}
              <div class="access-group-item__count">
                {{ accessGroup.locations.length }} {{ accessGroup.locations.length === 1 ? 'lokation' : 'lokationer' }}
              </div>
            </span>
            <div class="access-group-item__more-link" [matMenuTriggerFor]="menu" (menuOpened)="onMenuOpened(groupIndex)">Se mere</div>
            <mat-menu #menu="matMenu">
              <div class="access-emulator__access-group-item--more">
                <div class="location-card">
                  <div class="location-card__header">
                    <img src="/assets/img/emulator-app-charger-icon.svg" alt="OK logo" class="location-card__logo" />
                    @if (accessGroup.compactOrganizationLogoLink) {
                      <img
                        src="{{ accessGroup.compactOrganizationLogoLink }}"
                        class="location-card__organization-logo"
                        />
                    }
                    <div class="location-card__title-wrapper">
                      <div class="location-card__title">{{ accessGroup.organizationName }}</div>
                      <div class="location-card__count">
                        {{ accessGroup.locations.length }} {{ accessGroup.locations.length === 1 ? 'lokation' : 'lokationer' }}
                      </div>
                      <div class="location-card__access-group">
                        Adgangsgruppe:
                        <strong>{{ accessGroup.accessGroupName }}</strong>
                      </div>
                    </div>
                  </div>
                  <div class="location-card__access-info">
                    @if (accessGroup.activeFrom && accessGroup.activeTo) {
                      <mat-icon
                        class="location-card__access-icon"
                      matTooltip="Brugeren har adgang fra {{ accessGroup.activeFrom | date: 'shortDate' }} til og med {{
                        accessGroup.activeTo | date: 'shortDate'
                      }}"
                        >access_time</mat-icon
                        >
                        <span>Adgang udløber {{ accessGroup.activeTo | date: 'shortDate' }}</span>
                      }
                      @if (!accessGroup.activeTo) {
                        <mat-icon class="access-emulator__access-group-item--access-icon" matTooltip="Brugeren har permanent adgang"
                          >access_time</mat-icon
                          >
                          <span>Permanent adgang</span>
                        }
                      </div>
                      <div class="location-card__location-list">
                        @for (location of accessGroup.locations; track location; let locationIndex = $index) {
                          <div class="location-card__location-item">
                            <div class="location-card__location-icon" [id]="'map-' + groupIndex + '-' + locationIndex"></div>
                            <div class="location-card__location-text">
                              <strong>{{ location.name }}</strong>
                              <span>{{ location.address }}</span>
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </mat-menu>
              </div>
              @if (accessGroup.locations.length > 0) {
                <div [id]="'map-' + groupIndex" class="access-group-item__map"></div>
              }
              <div class="access-group-item__access-info">
                @if (accessGroup.activeFrom && accessGroup.activeTo) {
                  <mat-icon
              matTooltip="Brugeren har adgang fra {{ accessGroup.activeFrom | date: 'shortDate' }} til og med {{
                accessGroup.activeTo | date: 'shortDate'
              }}"
                    >access_time</mat-icon
                    >
                    <span>Adgang udløber {{ accessGroup.activeTo | date: 'shortDate' }}</span>
                  }
                  @if (!accessGroup.activeTo) {
                    <mat-icon matTooltip="Brugeren har permanent adgang">access_time</mat-icon>
                    <span>Permanent adgang</span>
                  }
                </div>
              </div>
            }
          </div>
          <div class="access-emulator__bottom"></div>
        </div>
      </mat-dialog-content>
